import { render } from "./TabMore.vue?vue&type=template&id=319491b0&scoped=true"
import script from "./TabMore.vue?vue&type=script&lang=js"
export * from "./TabMore.vue?vue&type=script&lang=js"

import "./TabMore.vue?vue&type=style&index=0&id=319491b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319491b0"]])

export default __exports__